module.exports = __webpack_public_path__ + "img/boiler_dark.f528aaef.png";